import { all } from 'redux-saga/effects';

// eslint-disable-next-line import/no-cycle
import UnsubscribeSagaWatcher from '../components/UnsubscribeNewsletter/sagas';

import { accountPreferencesSagaWatcher } from './accountPreferences/sagas';
import adminRootSaga from './adminPanel/sagas';
import { agencyLogoSagaWatcher } from './agencyLogo/sagas';
import areasSagaWatcher from './areas/sagas';
import calendarSagaWatcher from './calendar/sagas';
import dairyRevenueProtectionSagaWatcher from './dairyRevenueProtection/sagas';
import salesStatisticsSagaWatcher from './drpSalesStatistics/sagas';
import educationModuleSagaWatcher from './educationModule/sagas';
import { endorsementSagaWatcher } from './endorsement/sagas';
import historicalDataSagaWatcher from './historicalData/sagas';
import lrpSagaWatcher from './lrp/sagas';
import managementReportSagaWatcher from './managementReports/sagas';
import operationContactRootSaga from './operationContact/sagas';
import { operationPageSagaWatcher } from './operationPage/sagas';
import { operationPreferencesSagaWatcher } from './operationPreferences/sagas';
import { priceReportSagaWatcher } from './priceReport/sagas';
import { priceTrendsSagaWatcher } from './priceTrends/sagas';
import projectionDataSagaWatcher from './projectionData/sagas';
import scenarioSagaWatcher from './scenario/sagas';
import scenarioAnalysisSagaWatcher from './scenarioAnalysis/sagas';
import { tagSagaWatcher } from './tags/sagas';
import { tagTypeSagaWatcher } from './tagTypes/sagas';
import userAgentSaga from './userAgent/sagas';

// eslint-disable-next-line import/no-default-export -- rootSaga is conventionally a default export
export default function* rootSaga(): Generator {
  yield all([
    managementReportSagaWatcher(),
    areasSagaWatcher(),
    dairyRevenueProtectionSagaWatcher(),
    adminRootSaga(),
    scenarioSagaWatcher(),
    salesStatisticsSagaWatcher(),
    lrpSagaWatcher(),
    educationModuleSagaWatcher(),
    endorsementSagaWatcher(),
    historicalDataSagaWatcher(),
    operationPageSagaWatcher(),
    agencyLogoSagaWatcher(),
    operationContactRootSaga(),
    accountPreferencesSagaWatcher(),
    operationPreferencesSagaWatcher(),
    priceReportSagaWatcher(),
    priceTrendsSagaWatcher(),
    calendarSagaWatcher(),
    projectionDataSagaWatcher(),
    scenarioAnalysisSagaWatcher(),
    tagSagaWatcher(),
    tagTypeSagaWatcher(),
    UnsubscribeSagaWatcher(),
    userAgentSaga()
  ]);
}
